import { connect } from 'react-redux'
import { closeLoansNow } from 'src/actions/homeowner'

const withOnClickCloseLoans = connect(
  null,
  dispatch => ({
    onClick: () => dispatch(closeLoansNow())
  })
)

export default withOnClickCloseLoans
